import { TextField } from '@mui/material';

type InputProps = {
  errorFlag: boolean;
  message: string;
  field: object;
  label: string;
  type?: string;
  className?: string;
  endAdornment?: React.ReactElement;
  multiline?: boolean;
  minRows?: number;
};

const Input = ({ errorFlag, message, field, label, type, className, endAdornment, multiline, minRows }: InputProps) => (
  <TextField
    error={errorFlag}
    helperText={message}
    size="small"
    fullWidth
    label={label}
    variant="outlined"
    multiline={multiline}
    {...(minRows && { minRows })}
    {...(type && { type })}
    {...(className && { className })}
    {...field}
    InputProps={{ ...(endAdornment && { endAdornment }) }}
  />
);

export default Input;
